<template>
	<div>
		<modalconfirm ref="modalconfirmAddRetur" @action="proccessRetur"/>
		<div class="text-h5">Tambah Retur</div>
		<v-card class="mt-3" outlined>
			<v-form ref="formRetur" role="form" v-on:submit.prevent="addRetur">
				<v-card-text class="pt-2">
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="12" sm="3" md="3" class="py-0">
							<v-row>
								<v-col cols="12" md="12">
									<v-autocomplete :items="supplierResults" v-model="retur_supplier" item-text="supplier_name" item-value="supplier_id" label="Supplier" no-data-text="Tidak ada data yang sesuai" @focus="() => responseError.supplier_id=''" :error-messages="responseError.supplier_id" :rules="[inputrules.required]" outlined dense>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-textarea v-model="retur_note" label="Catatan" rows="3" height="120" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-alert v-if="responseError.product" type="error" elevation="1">
								{{responseError.product}}
							</v-alert>
							<v-simple-table class="white-row">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="25%" class="text-left">Kode Produk</th>
											<th width="15%" class="text-left">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<div class="d-flex">
													<div>
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromRetur(index)">
																	<v-icon dark>mdi-delete</v-icon>
																</v-btn>
															</template>
															<span>Hapus</span>
														</v-tooltip>
													</div>
												</div>
											</td>
											<td>
												<v-autocomplete :items="productsNotSelected" :filter="customFilter" return-object item-text="product_name" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-3 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-autocomplete>
											</td>
											<td> {{ product.data.product_code }} </td>
											<td>
												<v-currency-field v-model.lazy="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" outlined dense hide-details="auto" background-color="white" class="py-3 details-mb-0"></v-currency-field>
											</td>
										</tr>
									</tbody>
									<tfoot>
									</tfoot>
								</template>
							</v-simple-table>
							<!-- <v-btn light depressed color="primary" @click="addProduct" :disabled="!retur_supplier">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Produk</div>
							</v-btn> -->
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-btn light depressed color="primary" @click="addProduct" :disabled="!retur_supplier">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Produk</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn depressed class="text-capitalize" color="primary darken-1" type="submit">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			dialog: false,
			menu: false,
			list_payment: ['Lunas', 'Tempo'],
			retur_supplier: '',
			retur_payment: '',
			productsSelected: [],
			retur_note: '',
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Jumlah Permintaan', value: 'quantity', align: 'end', width: "15%"},
			{ text: 'Action', value: 'action', sortable: false},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('retur', ['supplierProducts', 'response', 'responseError', 'supplierResults', 'alertMultiple']),

		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const productSelected = this.productsSelected.map((el) => el.data)
				return this.supplierProducts.map((el) => {
					if (productSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.supplierProducts
		},
	},
	methods: {
		...mapActions('retur', ['getSupplierProducts', 'createRetur', 'getSupplierOption']),
		...mapMutations('retur', ['saveResponse', 'clearDataRetur', 'setSupplierProducts', 'validationError', 'multipleAlert']),
		...mapMutations(['setOverlay']),

		customFilter (item, queryText) {
			const textOne = item.product_code.toLowerCase()
			const textTwo = item.product_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		addProduct() {
			this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: '',
					product_name: '',
					quantity: '0',
				},
			})
		},
		deletefromRetur(index){
			this.productsSelected.splice(index, 1)
		},
		addRetur(){
			if (this.$refs.formRetur.validate() && this.productsSelected.length > 0) {
				this.$refs.modalconfirmAddRetur.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
				this.$refs.modalconfirmAddRetur.showConfirm()
			}
		},
		async proccessRetur(){
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddRetur.hideConfirm()
			let product = await this.productsSelected.map( (el) => {
				return {
					product_name: el.data.product_name,
					product_id: el.data.product_id,
					price: el.data.price,
					quantity: el.data.quantity,
				}
			})
			let params = await {
				supplier_id: this.retur_supplier,
				note: this.retur_note,
				product: product
			}
			await this.createRetur(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
			await this.setOverlay(false)
		},
		resetForm(){
			this.saveResponse('')
			this.$refs.formRetur.resetValidation()
			this.productsSelected = []
			this.retur_supplier = ''
			this.retur_note = ''
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah Retur`)
		this.getSupplierOption({limit:100})
	},
	beforeDestroy() {
		this.clearDataRetur()
	},
	watch: {
		retur_supplier(val){
			if (val) {
				this.getSupplierProducts({supplier_id: val})
			} else {
				this.setSupplierProducts([])
			}
			this.productsSelected = []
		}
	}
}
</script>